import React from 'react';

const AboutUs = () => {
  return (
    <section className="about-us-section" id="nosotros">
      <div className="about-us-container">
        <div className="about-us-text">
          <h2 className="section-title">Sobre Verissa Diseño Interior</h2>
          <p className="about-us-intro">
            Verissa Diseño Interior nació hace 21 años en Monterrey, Nuevo León con un solo objetivo:
            transformar ideas en espacios reales.
          </p>
          <p>
            Desde sus inicios, Verissa ha crecido con esfuerzo, creatividad y compromiso, expandiendo su alcance
            a lo largo de toda la República Mexicana. Nos especializamos en llevar proyectos desde su concepción
            hasta su ejecución final, cuidando cada detalle para lograr un equilibrio entre calidad, funcionalidad
            y durabilidad.
          </p>
          <p>
            Nuestra filosofía es clara: cada cliente debe sentirse acompañado, escuchado y seguro de haber recibido
            no solo un producto de alta calidad, sino también un servicio de consultoría profesional que se ajusta
            a las necesidades de cada proyecto.
          </p>
          <p>
            Para lograrlo, hemos construido relaciones sólidas con marcas, proveedores y fabricantes de primer nivel.
            Seleccionamos cuidadosamente cada producto de nuestro catálogo, garantizando que todo lo que ofrecemos
            cumpla con los más altos estándares de diseño, resistencia y calidad, tanto para nuestros clientes como
            para quienes harán uso de los espacios.
          </p>
        </div>
        <div className="about-us-side">
          <div className="about-us-logo-card">
            <div className="about-us-logo-circle">
              <img src="/assets/Logos/logo.png" alt="Verissa Diseño Interior" />
            </div>
            <div className="about-us-logo-text">
              <span>21 años</span>
              <p>Transformando ideas en espacios reales</p>
            </div>
          </div>
          <div className="about-us-highlight">
            <div className="about-us-highlight-badge">Presencia nacional</div>
            <p>
              Acompañamos proyectos corporativos, comerciales, educativos y de salud en diferentes ciudades de México,
              conectando a nuestros clientes con soluciones de mobiliario de clase mundial.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;

